<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    // 判断链接中的渠道名 默认为kaisa 区分账密 集团名与集团uid
    if (this.getQueryVariable("xnhqd")) {
      let xnhqd = this.getQueryVariable("xnhqd");
      if (xnhqd == "csks") {
        this.$store.commit("setQudao", "长沙凯萨");
        this.$store.commit("setQdAccount", "csks");
        this.$store.commit("setQdPwd", "csksD6xDA1G");
        this.$store.commit("setQdCompany", "祝您幸福0");
        this.$store.commit(
          "setQdCompanyUid",
          "a0d22980daba4289842e7c12f6a78c35"
        );
      } else if (xnhqd == "fdx") {
        this.$store.commit("setQudao", "深圳飞碟星互联网推广");
        this.$store.commit("setQdAccount", "fanmiao");
        this.$store.commit("setQdPwd", "fanmiao!@#");
        this.$store.commit("setQdCompany", "欢迎来电1");
        this.$store.commit(
          "setQdCompanyUid",
          "1cff71469d704cb7929934cf1b15392f"
        );
      } else if (xnhqd == "feidiexingzhitong") {
        this.$store.commit("setQudao", "深圳飞碟星直投");
        this.$store.commit("setQdAccount", "feidiexingzhitong");
        this.$store.commit("setQdPwd", "fanmiao!@#zhitong");
        this.$store.commit("setQdCompany", "祝你幸福0");
        this.$store.commit(
          "setQdCompanyUid",
          "4e5019b1974d4a4a80968cd68e9cd686"
        );
      } else if (xnhqd == "hzzhijian") {
        this.$store.commit("setQudao", "杭州致健");
        this.$store.commit("setQdAccount", "hzzhijian");
        this.$store.commit("setQdPwd", "hzzhijianSkYBDaGZ");
        this.$store.commit("setQdCompany", "天天快乐0");
        this.$store.commit(
          "setQdCompanyUid",
          "f9de7930265e46d9ad9eaaeb22de0f15"
        );
      } else if (xnhqd == "jsgy") {
        this.$store.commit("setQudao", "江苏冠优直投");
        this.$store.commit("setQdAccount", "jsguanyouzhitong");
        this.$store.commit("setQdPwd", "fajsguanyonBDaGZ");
        this.$store.commit("setQdCompany", "祝您健康快乐0");
        this.$store.commit(
          "setQdCompanyUid",
          "754e0b49d7dc44febcf8c9f410f98d19"
        );
      } else if (xnhqd == "xnhown") {
        this.$store.commit("setQudao", "欣能汇公众号账号");
        this.$store.commit("setQdAccount", "xnhpublic");
        this.$store.commit("setQdPwd", "xnhpubliczGYuI");
        this.$store.commit("setQdCompany", "每天好心情0");
        this.$store.commit(
          "setQdCompanyUid",
          "8f44aa5e919c4befb19d185e895b7ceb"
        );
      } else if (xnhqd == "hzyunduan") {
        this.$store.commit("setQudao", "杭州沄端科技有限公司");
        this.$store.commit("setQdAccount", "hzyunduankeji");
        this.$store.commit("setQdPwd", "kysDrxCzG1ud");
        this.$store.commit("setQdCompany", "每天笑哈哈");
        this.$store.commit(
          "setQdCompanyUid",
          "06764edc23414187b42d46b828f856cd"
        );
      } else if (xnhqd == "zfkj") {
        this.$store.commit("setQudao", "铸锋科技");
        this.$store.commit("setQdAccount", "zhufeng666");
        this.$store.commit("setQdPwd", "zhufeng!@#xCzG");
        this.$store.commit("setQdCompany", "");
        this.$store.commit("setQdCompanyUid", "");
      } else if (xnhqd == "cmcc") {
        this.$store.commit("setQudao", "电信投放");
        this.$store.commit("setQdAccount", "dxtf");
        this.$store.commit("setQdPwd", "csanSkYBD1GwrXw");
        this.$store.commit("setQdCompany", "祝您生活快乐0");
        this.$store.commit(
          "setQdCompanyUid",
          "395786f4cf144ac3a99f83e6a81f9fdd"
        );
      } else if (xnhqd == "xmzy") {
        this.$store.commit("setQudao", "厦门中有直投");
        this.$store.commit("setQdAccount", "xmzyzt");
        this.$store.commit("setQdPwd", "uz6P01u4");
        this.$store.commit("setQdCompany", "祝您生活天天开心0");
        this.$store.commit(
          "setQdCompanyUid",
          "7c510dd3217f42f9a02533a927f311b0"
        );
      } else if (xnhqd == "hzrg") {
        this.$store.commit("setQudao", "杭州润歌网络直投");
        this.$store.commit("setQdAccount", "hzruige");
        this.$store.commit("setQdPwd", "hzruigeSddreDaGZ");
        this.$store.commit("setQdCompany", "祝您天天快乐");
        this.$store.commit(
          "setQdCompanyUid",
          "397588f92fbc47d293547c2d96381836"
        );
      } else if (xnhqd == "szzj") {
        this.$store.commit("setQudao", "深圳市讯扬科技有限公司");
        this.$store.commit("setQdAccount", "szzjsw");
        this.$store.commit("setQdPwd", "hzszzjswZFDS");
        this.$store.commit("setQdCompany", "天天好心情0");
        this.$store.commit(
          "setQdCompanyUid",
          "9b9133baad114fa8a2dab8f77a2e7ff6"
        );
      } else if (xnhqd == "szzj2") {
        this.$store.commit("setQudao", "深圳讯扬投放2");
        this.$store.commit("setQdAccount", "szzjsw2");
        this.$store.commit("setQdPwd", "hzszzjswZFDS222");
        this.$store.commit("setQdCompany", "恭喜发大财");
        this.$store.commit(
          "setQdCompanyUid",
          "e3277f2e6ed348e9b6b1ceb1fdca3ecd"
        );
      } else if (xnhqd == "szxy") {
        this.$store.commit("setQudao", "深圳市讯扬科技有限公司");
        this.$store.commit("setQdAccount", "szzjsw");
        this.$store.commit("setQdPwd", "hzszzjswZFDS");
        this.$store.commit("setQdCompany", "天天好心情0");
        this.$store.commit(
          "setQdCompanyUid",
          "9b9133baad114fa8a2dab8f77a2e7ff6"
        );
      } else if (xnhqd == "szxy2") {
        this.$store.commit("setQudao", "深圳讯扬投放2");
        this.$store.commit("setQdAccount", "szzjsw2");
        this.$store.commit("setQdPwd", "hzszzjswZFDS222");
        this.$store.commit("setQdCompany", "恭喜发大财");
        this.$store.commit(
          "setQdCompanyUid",
          "e3277f2e6ed348e9b6b1ceb1fdca3ecd"
        );
      } else if (xnhqd == "wytg") {
        this.$store.commit("setQudao", "我要推广投放");
        this.$store.commit("setQdAccount", "woyaotuiguang");
        this.$store.commit("setQdPwd", "Ixduiyfsppukjid");
        this.$store.commit("setQdCompany", "笑哈哈");
        this.$store.commit(
          "setQdCompanyUid",
          "d3694b5569164177b0fe86e4f1a387ed"
        );
      } else if (xnhqd == "zsgl") {
        this.$store.commit("setQudao", "成都众视广联投放");
        this.$store.commit("setQdAccount", "chengduzhongshi");
        this.$store.commit("setQdPwd", "sZWsbYrhzzhijian");
        this.$store.commit("setQdCompany", "恭喜恭喜");
        this.$store.commit(
          "setQdCompanyUid",
          "15dcab5a29d949ba9d0bbd9448c792b1"
        );
      } else if (xnhqd == "hzql") {
        this.$store.commit("setQudao", "杭州巧珑网络");
        this.$store.commit("setQdAccount", "qiaolong");
        this.$store.commit("setQdPwd", "sZkysD6xojian323");
        this.$store.commit("setQdCompany", "幸福美满");
        this.$store.commit(
          "setQdCompanyUid",
          "73b9fad34ba84a08be6af5d9fb4fc2ee"
        );
      } else if (xnhqd == "bjbhxc") {
        this.$store.commit("setQudao", "北京博鸿迅驰");
        this.$store.commit("setQdAccount", "bohong");
        this.$store.commit("setQdPwd", "siuxjuYhfian888");
        this.$store.commit("setQdCompany", "满心欢喜0");
        this.$store.commit(
          "setQdCompanyUid",
          "d6661edd434d489688c37bb12bd43b48"
        );
      } else if (xnhqd == "chijintf") {
        this.$store.commit("setQudao", "赤金投放");
        this.$store.commit("setQdAccount", "chijintoufang");
        this.$store.commit("setQdPwd", "fsFvS2vA");
        this.$store.commit("setQdCompany", "幸福安康");
        this.$store.commit(
          "setQdCompanyUid",
          "3e4b667202be4700b7f1359a5a4ff95a"
        );
      } else if (xnhqd == "cdmh") {
        this.$store.commit("setQudao", "成都麦禾投放");
        this.$store.commit("setQdAccount", "chengdumaihetf");
        this.$store.commit("setQdPwd", "IPddfevopukjid");
        this.$store.commit("setQdCompany", "开开心心");
        this.$store.commit(
          "setQdCompanyUid",
          "3866173b612c4617b29e68de3f229f0a"
        );
      } else if (xnhqd == "zcpp") {
        this.$store.commit("setQudao", "智潮澎湃投放");
        this.$store.commit("setQdAccount", "zhichaotoufang");
        this.$store.commit("setQdPwd", "fsFvopufdss");
        this.$store.commit("setQdCompany", "美满幸福");
        this.$store.commit(
          "setQdCompanyUid",
          "22fe4e2936c445b1acdb02412ecd4b82"
        );
      } else if (xnhqd == "csksxwsxh") {
        // 凯萨视宣号投放
        this.$store.commit("setQudao", "凯萨视宣号投放");
        this.$store.commit("setQdAccount", "cskssxhtf");
        this.$store.commit("setQdPwd", "csksD6xDA1G");
        this.$store.commit("setQdCompany", "每天都是好心情");
        this.$store.commit(
          "setQdCompanyUid",
          "c49ebe577b0c4a91aa8655636a1a5108"
        );
      } else if (xnhqd == "fdxxwsxh") {
        // 飞碟星视宣号投放
        this.$store.commit("setQudao", "深圳飞碟星视宣号投放");
        this.$store.commit("setQdAccount", "fdxsxhtf");
        this.$store.commit("setQdPwd", "fascdeto!itong");
        this.$store.commit("setQdCompany", "每天都有好心情1029");
        this.$store.commit(
          "setQdCompanyUid",
          "c22a3424df4144f6b7643aff95901800"
        );
      } else if (xnhqd == "xnhsxh") {
        // 欣能汇视宣号投放
        this.$store.commit("setQudao", "欣能汇公众号账号");
        this.$store.commit("setQdAccount", "xnhpublic");
        this.$store.commit("setQdPwd", "xnhpubliczGYuI");
        this.$store.commit("setQdCompany", "每天都有好心情1115");
        this.$store.commit(
          "setQdCompanyUid",
          "c49ebe577b0c4a91aa86556361115122"
        );
      } else if (xnhqd == "xnhonecircle") {
        // 欣能汇视宣号投放
        this.$store.commit("setQudao", "欣能汇");
        this.$store.commit("setQdAccount", "xnhonecircle");
        this.$store.commit("setQdPwd", "xnhonecirclezGYuI");
        this.$store.commit("setQdCompany", "欣能汇");
        this.$store.commit(
          "setQdCompanyUid",
          "666666"
        );
      } else if (xnhqd == "sxhown10") {
        // 欣能汇视宣号投放
        this.$store.commit("setQudao", "精英版自投");
        this.$store.commit("setQdAccount", "sxhzitou");
        this.$store.commit("setQdPwd", "Ixsxhzitoujid");
        this.$store.commit("setQdCompany", "精英版自投");
        this.$store.commit("setQdCompanyUid", "精英版自投");
      } else if (xnhqd == "wytgsxh10") {
        // 欣能汇视宣号投放
        this.$store.commit("setQudao", "我要推广投放视宣号");
        this.$store.commit("setQdAccount", "woyaotuigugang");
        this.$store.commit("setQdPwd", "IxSkYBDitoujaGZ");
        this.$store.commit("setQdCompany", "我要推广投放视宣号");
        this.$store.commit("setQdCompanyUid", "我要推广投放视宣号");
      } else {
        this.$toast("程序有误，请立刻联系技术!!!");
      }
    } else {
      this.$store.commit("setQudao", "互联网彩铃通用");
      this.$store.commit("setQdAccount", "qwvedioInternet");
      this.$store.commit("setQdPwd", "dsuop!FYuI!!");
      this.$store.commit("setQdCompany", "互联网彩铃通用");
      this.$store.commit("setQdCompanyUid", "互联网彩铃通用");
    }
  },
  mounted() {

  },
  methods: {
    // 获取链接中的参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0;i < vars.length;i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<style>
html,
body {
  position: relative;
  width: 100%;
  height: 100%;
  user-select: none;
  -webkit-user-select: none;
  background: #f5f5f5;
  overflow: hidden;
}
li {
  list-style: none;
}
input {
  padding: 0;
  margin: 0;
}

#app {
  width: 100%;
  height: 100%;
  position: relative;
  font-size: 0.3rem;
}

.czcCenterCss {
  display: flex;
  justify-content: center;
  align-items: center;
}

.czcCenterCssCol {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.bottomText {
  width: 100%;
  height: 0.5rem;
  color: #ffffff;
  font-size: 0.2rem;
  margin-bottom: 0.3rem;
}

/* 旋转效果 */
@keyframes rotataZ {
  0% {
    -webkit-transform: rotateZ(0deg);
  }

  100% {
    -webkit-transform: rotateZ(360deg);
  }
}

/* 显示隐藏效果 */
@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* 放大缩小效果 */
@keyframes scaleTrans {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

/* 弹窗打开动画效果 用法<transition name="fade"></transition> */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #999999;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #999999;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999999;
}

input::-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #999999;
}

::-webkit-input-placeholder {
  font-size: 0.28rem;
  font-weight: 400;
  color: #999999;
}

.ios-bottom {
  padding-bottom: env(safe-area-inset-bottom);
}

/* 暂停时显示播放按钮 */
.vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started .vjs-big-play-button {
  display: block;
}

/* 播放按钮变○圆形 */
.video-js .vjs-big-play-button {
  font-size: 0.2rem;
  line-height: 0.7rem;
  height: 0.7rem;
  width: 0.7rem;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5);
  border-width: 0.15em;
  margin-top: -1.25em;
  margin-left: -1.75em;
}
/* 中间的播放箭头 */
.vjs-big-play-button .vjs-icon-placeholder {
  font-size: 0.5rem;
}
/* 加载圆圈 */
.vjs-loading-spinner {
  font-size: 2.5em;
  width: 2em;
  height: 2em;
  border-radius: 1em;
  margin-top: -1em;
  margin-left: -1.5em;
}

/* 点击屏幕切换播放/暂停 */
.video-js.vjs-playing .vjs-tech {
  pointer-events: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue